import DataService from "./utils/dataservice/DataService";

// Create a custom DataService instance for order status with different base URL
class OrderStatusDataService extends DataService {
  constructor() {
    super();
    // Override the base URL to use /api/ instead of /api/admin
    this._baseUrl = process.env.REACT_APP_API_URL?.replace('/api/admin', '/api') || 'jamborecords-devapi.scouting.org/api';
  }
}

const orderStatusDataService = new OrderStatusDataService();

export default class OrderStatusService {
  static async getOrderStatusList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.status ? `status=${data.status}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await orderStatusDataService.get(`order/status${queryString}`);
  }

  static async postOrderStatus(data) {
    return await orderStatusDataService.post(`order/status`, data);
  }

  static async patchOrderStatus(id, data) {
    return await orderStatusDataService.patch(`order/status/${id}`, data);
  }

  static async deleteOrderStatus(id) {
    return await orderStatusDataService.delete(`order/status/${id}`);
  }
}

